import Desktop from "./Desktop";
import './App.css'
function App() {
    return (
        <Desktop/>
    );
}

export default App;
